<template>
  <div class="card-qr-code">
    <QRCodeCanvas :value="resolvedSourceValue" :size="40" />
  </div>
</template>

<script>
import sourceFieldReferenceField from '@baserow/modules/database/mixins/sourceFieldReferenceField'
import QRCodeCanvas from '@baserow/modules/database/components/field/QRCodeCanvas'

export default {
  name: 'RowCardFieldQRCode',
  components: { QRCodeCanvas },
  mixins: [sourceFieldReferenceField],
  height: 48,
  props: {
    row: { type: Object, required: true },
    field: { type: Object, required: true },
    value: { type: null, default: null },
  },
}
</script>
